import { Link } from "react-router-dom";
import { BRAND, IMAGES, QUOTE_URL } from "@/lib/constants";
import { Phone } from "lucide-react";

export default function Header() {
  return (
    <header className="fixed top-0 inset-x-0 z-50 glass-nav" data-testid="site-header">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="header-logo-link">
          <img src={IMAGES.logo} alt="Cozy Keys Service" className="h-12 w-12 rounded-full object-cover ring-1 ring-[rgba(212,175,55,0.3)]" />
          <div className="leading-tight hidden sm:block">
            <div className="font-serif-display text-ivory text-xl tracking-tight">Cozy Keys</div>
            <div className="overline" style={{fontSize: '0.55rem'}}>Service · Estd 2025</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-10 text-sm text-ivory-muted">
          <a href="/#services" className="hover:text-ivory transition" data-testid="nav-services">Services</a>
          <a href="/#date-night" className="hover:text-ivory transition" data-testid="nav-date-night">Date Night</a>
          <a href="/#fleet" className="hover:text-ivory transition" data-testid="nav-fleet">Fleet</a>
          <a href="/#prom" className="hover:text-ivory transition" data-testid="nav-prom">Prom</a>
          <Link to="/rentals" className="hover:text-ivory transition" data-testid="nav-rentals">Rentals</Link>
          <a href="/#contact" className="hover:text-ivory transition" data-testid="nav-contact">Contact</a>
        </nav>

        <div className="flex items-center gap-4">
          <a href={`tel:${BRAND.phone}`} className="hidden md:flex items-center gap-2 text-xs text-ivory-muted hover:text-gold transition" data-testid="header-phone">
            <Phone className="h-3.5 w-3.5" />
            <span className="tracking-widest">{BRAND.phoneVanity}</span>
          </a>
          <a href={QUOTE_URL} target="_blank" rel="noopener noreferrer" className="hidden md:inline-block btn-ghost-gold px-4 py-3" data-testid="header-quote-btn">
            Quote
          </a>
          <Link to="/book" className="btn-gold px-5 py-3" data-testid="header-book-btn">
            Book a Ride
          </Link>
        </div>
      </div>
    </header>
  );
}
